/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioQueryVariables = {||};
export type PortfolioQueryResponse = {|
  +userPortfolio: ?{|
    +marketCurrentTotal: ?number,
    +percentageDiff: ?number,
    +invested: ?number,
    +profitLoss: ?number,
  |}
|};
export type PortfolioQuery = {|
  variables: PortfolioQueryVariables,
  response: PortfolioQueryResponse,
|};
*/


/*
query PortfolioQuery {
  userPortfolio {
    marketCurrentTotal
    percentageDiff
    invested
    profitLoss
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PortfolioNode",
    "kind": "LinkedField",
    "name": "userPortfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketCurrentTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageDiff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invested",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profitLoss",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PortfolioQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "01d92e2703eb78d9a2393e39fc1be39c",
    "id": null,
    "metadata": {},
    "name": "PortfolioQuery",
    "operationKind": "query",
    "text": "query PortfolioQuery {\n  userPortfolio {\n    marketCurrentTotal\n    percentageDiff\n    invested\n    profitLoss\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '17ad58acbed1679f07f8c76753695310';

module.exports = node;
